export default __webpack_public_path__ + "static/media/sprirt-egypt-game.2ea73dcf.png";